import React from 'react';

type IntroTitleProps = {
  title: string;
  subtitle: string;
};

const IntroTitle: React.FC<IntroTitleProps> = ({ title, subtitle }) => {
  return (
    <div className={'items-start self-stretch gap-2'}>
      <p className='text-2xl font-500 text-vulcan-950'>{title}</p>
      <p className='text-sm font-400 leading-6 text-lynch-700'>{subtitle}</p>
    </div>
  );
};

export default IntroTitle;
